import ContactInfoContainer from './ContactInfoContainer';

export default ContactInfoContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/ContactInfo/index.js